import {FETCHING_SCREEN_ERROR, FETCHING_SCREEN_SUCCESS} from '../../actions/generic/types';
import _ from 'lodash';

const INITIAL_STATE = {
    screenInfo: {}
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case FETCHING_SCREEN_SUCCESS:
            // var newState = {...state, screenInfo: action.payload};
            // console.log(newState);
            // return newState;
            //console.log('got reducer payload:');
            //console.log(action.payload);
            return action.payload;
        case FETCHING_SCREEN_ERROR:
            //return {...state, screenInfo: INITIAL_STATE};
            return state;
        default:
            return state;
    }
}